import type { BlockGridFourCells } from 'types/block-grid-four-cells';

import React from 'react';

import { Paragraph, Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import Figure from './figure';

const GridFourCells: React.FC<BlockGridFourCells> = ({
  sectionId,
  image,
  secondCellTitle,
  secondCellDescription,
  secondCellIcon,
  thirdCellTitle,
  thirdCellDescription,
  fourthCellTitle,
  fourthCellDescription,
}) => {
  const cellsClasses = 'py-6 px-8 rounded-2xl';
  return (
    <Wrap
      id={sectionId}
      className="gap-y-6 lg:grid-cols-2 xl:grid-rows-4-auto lg:gap-x-16 items-start"
    >
      {image ? (
        <Figure
          {...image}
          className="inline-grid xl:col-start-1 xl:row-start-1 xl:row-span-2"
          classNameImage="rounded-2xl xl:h-164"
        />
      ) : null}
      {secondCellTitle || secondCellDescription ? (
        <div
          className={[
            cellsClasses,
            'order-first lg:order-2 xl:col-start-2 xl:row-start-1 grid gap-y-8 justify-items-center bg-lilac-50 xl:h-128',
          ].join(' ')}
        >
          {secondCellIcon && (
            <Figure {...secondCellIcon} className="self-end" />
          )}
          <div className="flex flex-col gap-y-6">
            {secondCellTitle && (
              <HeadingBody
                level="3"
                tagName="h3"
                title={secondCellTitle}
                className="font-semibold text-center"
              />
            )}
            {secondCellDescription && (
              <Paragraph
                size="large"
                className="text-gray-700 text-center"
                dangerouslySetInnerHTML={{ __html: secondCellDescription }}
              />
            )}
          </div>
        </div>
      ) : null}
      {thirdCellTitle || thirdCellDescription ? (
        <div
          className={[
            cellsClasses,
            'xl:col-start-1 xl:row-start-3 grid gap-y-6 bg-green-50',
          ].join(' ')}
        >
          {thirdCellTitle && (
            <HeadingBody
              level="3"
              tagName="h3"
              title={thirdCellTitle}
              className="font-semibold"
            />
          )}
          {thirdCellDescription && (
            <Paragraph
              size="large"
              className="text-gray-700"
              dangerouslySetInnerHTML={{ __html: thirdCellDescription }}
            />
          )}
        </div>
      ) : null}
      {fourthCellTitle || fourthCellDescription ? (
        <div
          className={[
            cellsClasses,
            'order-first lg:order-last xl:col-start-2 xl:row-start-2 xl:row-span-2 flex flex-col gap-y-6 justify-center items-center bg-lilac-50 xl:h-96',
          ].join(' ')}
        >
          {fourthCellTitle && (
            <HeadingBody
              level="3"
              tagName="h3"
              title={fourthCellTitle}
              className="!text-6xl lg:!text-7xl text-purple-500 font-semibold text-center"
            />
          )}
          {fourthCellDescription && (
            <Paragraph
              size="large"
              className="text-purple-500 text-center lg:px-16"
              dangerouslySetInnerHTML={{ __html: fourthCellDescription }}
            />
          )}
        </div>
      ) : null}
    </Wrap>
  );
};

export default GridFourCells;
